import { Box } from "@mui/material";
import pluralize from "pluralize";
import useAPI from "../../../../../../api/hooks/useAPI";
import CopyButton from "../../../../../../components/buttons/CopyButton";
import ExportButton from "../../../../../../components/buttons/ExportButton";
import { Toast } from "../../../../../../components/Toast";
import { getEntityTypeDisplayName } from "../../../../../../utils/utils";
import { affectedEntitiesToCsv } from "../../EntitiesSection/ExportTable";

export default function EntitiesActionButtons({
  entitiesByType,
  checkedEntityIDs,
  entityType,
}) {
  const { trackEvent } = useAPI();

  const exportRelatedEntitiesToCSV = () => {
    trackEvent(
      `User exported ${checkedEntityIDs.length} ${entityType} entities from related entities table to CSV`
    );
    affectedEntitiesToCsv(null, entitiesByType[entityType], checkedEntityIDs);
  };

  const handleCopyChecked = () => {
    trackEvent("User copied misconfigured entities to clipboard");
    let entityNamesToCopy = [];
    entityNamesToCopy = entitiesByType[entityType]
      .filter((entity) => {
        const isChecked = checkedEntityIDs.includes(entity?.entity_id);
        return isChecked;
      })
      .map((entity) => {
        return entity?.display_name;
      });
    navigator.clipboard.writeText(entityNamesToCopy.join(", "));
    Toast.success(
      `Copied selected ${pluralize(
        entityType,
        checkedEntityIDs.length
      )} to clipboard!`
    );
  };

  return (
    <Box display="flex" gap={1}>
      <CopyButton
        handleCopy={() => {
          handleCopyChecked();
        }}
        itemsCount={checkedEntityIDs.length || 0}
        itemName={getEntityTypeDisplayName(entityType) || "entity"}
      />
      <ExportButton handleExport={exportRelatedEntitiesToCSV} />
    </Box>
  );
}
